import styles from './FJGeneratingLoadingModal.module.less';
import FJLoading from '../../../common/components/FJLoading/FJLoading.tsx';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton.tsx';

interface Props {
    desc: string;
    onclose?: () => void;
    onlyLoading?: boolean;
}

const FJGeneratingLoadingModal = ({ desc, onclose, onlyLoading }: Props) => {
    return (
        <div className={styles.content} style={{ width: onlyLoading ? 'auto' : '' }}>
            <div className={styles.loading}>
                <FJLoading strokeColor='#A8ACBC' style={{ width: '18', height: '18' }} />
            </div>
            {!onlyLoading && <div className={styles.text}>{desc}</div>}
            {!onlyLoading && (
                <FJButton type={FJButtonType.DEFAULT} className={styles.btn} onClick={onclose} text='cancel' />
            )}
        </div>
    );
};

export default FJGeneratingLoadingModal;
